import { Box, Button, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getText } from "../../libs/utils";
import API from "../../libs/API";



export default function PromptAML({ onAccept, open, onDecline, loading }) {
  const [text, setText] = useState({});

  const getPageContent = (page) => {
    API.getViewPage(page).then((page) => {
      page?.pageParams ? setText(page?.pageParams) : setText({
        title: '',
        content: '404'
      });
    })
  }

  useEffect(() => {
    if (open === 'fromBank' || open === 'toBank') {
      getPageContent("/rule" + open)
    }

    return () => {
    };
  }, [open]);


  return (
    <>
      <Dialog open={!!open} maxWidth="sm"
        PaperProps={{
          sx: {
            maxWidth: 370
          }
        }}

        onClose={onDecline}>
        {open === 'aml' && <DialogContent sx={{ textAlign: 'center' }}>
          <Typography variant="h4" fontSize={16}
            fontWeight={600}
            mb={0}>{getText('amlDiaTitle')} <a href={"/rules/aml"} target="_blank" >{getText('amlDiaTitleLink')}</a></Typography>
          <Typography variant="body1" sx={{ display: 'inline-block', margin: '8px 0 16px' }}>
            {getText('amlDiaText01')} <b> {getText('amlDiaText02')}</b>
          </Typography>
          <Typography variant="body2" sx={{ display: 'block', margin: '0px 0 12px' }}>
            {getText('amlDiaText03')}
          </Typography>

          <Stack spacing={1} direction="row" mb={'20px'} justifyContent={'center'}>
            <Button sx={{ fontSize: 10 }} onClick={() => window.open(getText('amlDiaCheckLink1Url'))}>
              {getText('amlDiaCheckLink1Label')}
            </Button>
            <Button sx={{ fontSize: 10 }} color="primary" onClick={() => window.open(getText('amlDiaCheckLink2Url'))}>
              {getText('amlDiaCheckLink2Label')}
            </Button>
          </Stack>
          <Button
            fullWidth
            variant="contained"

            sx={{
              py: 2,
              height: 48,
            }}
            disabled={loading}
            onClick={onAccept}
          >
            {getText('amlDiaAccept')}
          </Button>
        </DialogContent>}
        {open === 'fromBank' && text?.title && <DialogContent>
          <Typography variant="h4" fontSize={16} textAlign={'center'}>
            {text?.title}
          </Typography>
          <Typography variant="body2" color="textSecondary"
            width={"100%"}
            textAlign={'initial'}
            mb={3}
            sx={{
              '& > ol': { paddingInlineStart: 2 },
            }}
            dangerouslySetInnerHTML={{ __html: text.content }} />
          <Button
            fullWidth
            variant="contained"
            disabled={loading}
            onClick={onAccept}
            sx={{
              py: 2,
              height: 48,
            }}
          >
            {getText('amlDiaAccept')}
          </Button>
        </DialogContent>}

        {open === 'toBank' && text?.title && <DialogContent>
          <Typography variant="h4" fontSize={16} textAlign={'center'}>
            {text.title}
          </Typography>
          <Typography variant="body2" color="textSecondary"
            width={"100%"}
            textAlign={'initial'}
            mb={3}
            sx={{
              '& > ol': { paddingInlineStart: 2 },
            }}
            dangerouslySetInnerHTML={{ __html: text.content }} />
          <Button
            fullWidth
            variant="contained"
            disabled={loading}
            onClick={onAccept}
            sx={{
              py: 2,
              height: 48,
            }}
          >
            {getText('amlDiaAccept')}
          </Button>
        </DialogContent>}
      </Dialog>
    </>
  );
}

